import React from 'react';
import { rootReducer } from '../../redux/root-reducer';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import AppProvider from '../../AppProvider';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import appLocaleData from 'react-intl/locale-data/th';
import { RBH_MESSAGE_TH } from './testTH';
import { GlobalStyles } from '../../globalStyles';
import { Init } from '../../Init';
import { RBHTncModal, RBHModal } from '../components';
import { Loading } from '../loading';

const MockedNavigator = (props: { component: any }) => {
  return (
    <Router>
      <Switch>
        <Route exact path='/' component={props.component} />
      </Switch>
    </Router>
  );
};

export const getMockStore = (initialStore?: any) => {
  const store = createStore(rootReducer, initialStore || {});
  const originalDispatch = store.dispatch;
  store.dispatch = jest.fn(originalDispatch);
  return store;
};

export const WithMockedReduxStore = (params:
  {store: any, component: any, props?: any, initialStore?: any}) => {
  const _component = () => <params.component {...(params.props || {})}/>;
  return <Provider store={params.store}>
    <AppProvider>
      <>
        <GlobalStyles />
        { params.props?.isNotMountComponent ? null : <MockedNavigator component={_component} /> }
        <Init />
        <RBHTncModal />
        <RBHModal />
      </>
    </AppProvider>
    <Loading />
  </Provider>;
};

export const WrapperIntlProvider = (children: any) => {
  return <IntlProvider
    locale={getCurrentLanguage('th').locale}
    messages={getCurrentLanguage('th').lang.messages}>
    {children}</IntlProvider>;
};

const ThLang = {
  messages: {
    ...RBH_MESSAGE_TH
  },
  locale: 'th-TH',
  data: appLocaleData,
};

const options = [
  {
    locale: 'th',
    lang: ThLang
  },
  {
    locale: 'th',
    lang: ThLang
  }
];

function getCurrentLanguage(lang = 'th') {
  let selecetedLanguage = options[0];
  options.forEach((language) => {
    addLocaleData(language.lang.data);
    if (language.locale === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
